import React from 'react'
import {ErrorSummary, ErrorSummaryProps} from './ErrorSummary'

type InputErrorSummaryProps = Pick<ErrorSummaryProps, 'display' | 'testId'>

export const InputErrorSummary: React.VFC<InputErrorSummaryProps> = (props) => {
  return (
    <ErrorSummary
      display={props.display}
      headline={'申し訳ございませんが、入力内容に不備があるようです。'}
      detail={'お手数ですが、メッセージの表示された入力項目をご確認の上、もう一度ご入力ください。'}
      testId={props.testId}
    />
  )
}
